/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { AnnouncementContainer_settings$ref } from "./AnnouncementContainer_settings.graphql";
import { CommunityGuidelinesContainer_settings$ref } from "./CommunityGuidelinesContainer_settings.graphql";
import { PostCommentFormContainer_settings$ref } from "./PostCommentFormContainer_settings.graphql";
import { SuspendedInfoContainer_settings$ref } from "./SuspendedInfoContainer_settings.graphql";
import { UserBoxContainer_settings$ref } from "./UserBoxContainer_settings.graphql";
declare const _StreamContainer_settings$ref: unique symbol;
export type StreamContainer_settings$ref = typeof _StreamContainer_settings$ref;
export type StreamContainer_settings = {
    readonly reaction: {
        readonly sortLabel: string;
    };
    readonly " $fragmentRefs": PostCommentFormContainer_settings$ref & UserBoxContainer_settings$ref & CommunityGuidelinesContainer_settings$ref & SuspendedInfoContainer_settings$ref & AnnouncementContainer_settings$ref;
    readonly " $refType": StreamContainer_settings$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StreamContainer_settings",
    "type": "Settings",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "reaction",
            "storageKey": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sortLabel",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_settings",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_settings",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CommunityGuidelinesContainer_settings",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SuspendedInfoContainer_settings",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "AnnouncementContainer_settings",
            "args": null
        }
    ]
} as any);
(node as any).hash = '28744fac01f02d54b0fc15eb8ec4e0ca';
export default node;
